module.exports = __webpack_public_path__ + "static/media/Promotional-Products-Image.d364a8ae.png";